export const CHANGE_SUBCATEGORY_SELECTED_SUCCESS =
  "CHANGE_PLACE_SUBCATEGORY_SELECTED_SUCCESS";
export const SET_CUSTOMERS_LEGEND = "SET_CUSTOMERS_LEGEND";
export const CLEAR_LEGENDS_CACHE = "CLEAR_LEGENDS_CACHE";
export const SET_CUSTOMER_LOCATIONS = "SET_CUSTOMER_LOCATIONS";

export const SET_CUSTOMERS_ATTRIBUTE = "SET_CUSTOMERS_ATTRIBUTE";
export const CLEAR_DATA = "CLEAR_DATA";

export const FETCH_CREDIT_TRANSACTIONS_BEGIN =
  "FETCH_CREDIT_TRANSACTIONS_BEGIN";
export const FETCH_CREDIT_TRANSACTIONS_SUCCESS =
  "FETCH_CREDIT_TRANSACTIONS_SUCCESS";
export const FETCH_CREDIT_TRANSACTIONS_FAILURE =
  "FETCH_CREDIT_TRANSACTIONS_FAILURE";
